import { T } from "../../styles/GlobalStyles";
import { COLOR_ACCENT_DEFAULT } from "../../constants/colors";
import AthleosLogoSvg from "./AthleosLogoSvg";

const BrandLogo = ({ brandName, logoUrl, size = 36, accent }) => {
  if (logoUrl) {
    return (
      <div style={{ width: size, height: size, borderRadius: Math.round(size * 0.25), overflow: "hidden", flexShrink: 0 }}>
        <img src={logoUrl} alt={brandName || "AthleOS"} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </div>
    );
  }

  const accentColor = accent ?? T.accent ?? COLOR_ACCENT_DEFAULT;
  const iconSize = Math.round(size * 0.72);

  return (
    <div style={{
      width: size, height: size, borderRadius: Math.round(size * 0.22),
      overflow: "hidden", flexShrink: 0, background: "#0A0A0F",
      border: `1.5px solid ${accentColor}35`,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <AthleosLogoSvg width={iconSize} height={iconSize} fill={accentColor} />
    </div>
  );
};

export default BrandLogo;
